import {Component, EventEmitter, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FileUploadResponseDTO} from '../../../model/fileUploadResponseDTO';
import {CurrencyService} from '../../../services/currency-service';
import {ImportDetailsDialogResultModel} from './import-details-dialog-result.model';

@Component({
  templateUrl: './import-details-dialog.component.html',
  styleUrls: ['./import-details-dialog.component.scss']
})
export class ImportDetailsDialogComponent implements OnInit {

  resultEnum = ImportDetailsDialogResultModel;

  rows: Array<FileUploadResponseDTO>;
  allDoneAndWell: boolean;
  private informed = new EventEmitter<ImportDetailsDialogResultModel>();


  constructor(@Inject(MAT_DIALOG_DATA) public data,
              public currency: CurrencyService,
              public dialogRef: MatDialogRef<ImportDetailsDialogComponent>) {
  }

  ngOnInit(): void {
    this.dialogRef.disableClose = true;
    this.rows = this.data.rows;
    this.allDoneAndWell = this.data.allDoneAndWell;
  }

  ok(result: ImportDetailsDialogResultModel) {
    this.informed.emit(result);
    this.dialogRef.close();
  }

  public promise() {
    return new Promise<ImportDetailsDialogResultModel>(resolve => this.informed.subscribe((result) => resolve(result)));
  }
}
